// extracted by mini-css-extract-plugin
export default {"sensorInputColumn":"sensor-input-fields-module__sensorInputColumn--rKKTv"};